import { ITrackingService } from '@recruiting-solutions/rs-shared';
import { ArvBaseTrackingService } from './arv-base-tracking-service';

class ArvGmtTrackingService extends ArvBaseTrackingService implements ITrackingService {
    trackEvent(eventName: string, category: string, properties?: { [key: string]: any }) {
        const payload = { eventName: `${ArvBaseTrackingService.PREFIX}_${eventName}`, category, ...properties };
        this.pushToGtag(`${ArvBaseTrackingService.PREFIX}-cust-csb-event`, payload);
        this.pushToGtag(`ARVATO_cust_CSB_to_ARVATO`, payload);
    }

    trackPageView(eventName: string, pageType: string, properties?: { [key: string]: any }) {
        const payload = { eventName: `${ArvBaseTrackingService.PREFIX}_${eventName}`, pageType, ...properties };
        this.pushToGtag(`${ArvBaseTrackingService.PREFIX}-cust-csb-page-view`, payload);
    }

    trackException(error: Error, severityLevel: number, properties?: { [key: string]: any }) {
        const payload = { error, severityLevel, ...properties };
        this.pushToGtag(`${ArvBaseTrackingService.PREFIX}-cust-csb-event`, payload);
        this.pushToGtag(`ARVATO_cust_CSB_to_ARVATO`, payload);
    }

    trackClientEvent(eventName: string, severityLevel: number, properties?: { [key: string]: any }) {
        const payload = { eventName: `${ArvBaseTrackingService.PREFIX}_${eventName}`, severityLevel, ...properties };
        this.pushToGtag(`${ArvBaseTrackingService.PREFIX}-cust-csb-event`, payload);
        this.pushToGtag(`ARVATO_cust_CSB_to_ARVATO`, payload);
    }
}

export const arvGmtTrackingService = new ArvGmtTrackingService();
